import { setTokens } from "@/services/authTokens";
import { authService } from "@/services/authHttp";

export function extractErrorMessage(error) {
  const data = error?.response?.data;
  const msg = data?.message ?? data?.error ?? error?.message;
  if (typeof msg === "string") return msg;
  if (Array.isArray(msg)) return msg.join(", ");
  return "Sign in failed. Please try again.";
}

export async function loginWithApiAndRedirectToDashboard(email, password) {
  const res = await authService.login(String(email).trim(), password);
  const data = res?.data ?? res;
  const access = data?.access_token;
  const refresh = data?.refresh_token;
  if (!access || !refresh) {
    throw new Error("Invalid response from server.");
  }
  setTokens(access, refresh);
  window.location.assign("/");
}
